const getBasename = (filename: string): string => /^(.+)\..*$/.exec(filename)?.[1] ?? filename;

export function generateWinScript(filenames: string[], clientName: string, sessionName: string): string {
    const photoBases = filenames.map(getBasename).map(name => `"${name}"`).join(' ');

    return `@chcp 852 >nul
color D
cls
@ECHO OFF
setlocal EnableExtensions EnableDelayedExpansion

ECHO.
@ECHO                                                                    .
@ECHO    @@@@@@@@@@@@@             @@@@@       @@@@@@      @@@@@@   @@@@@@@@@@@
@ECHO    @@@@@@@@@@@@    (@@@@@@   @@@@@@     @@@@@@@      @@@@@  @@@@@@@@@@@@
@ECHO    @@@@@*            *@@@@@@  @@@@@*    @@@@@@@@    @@@@@   @@@@@@
@ECHO    @@@@@      @@@@@@@@@@@@@@@  @@@@@   @@@@@@@@@@  @@@@@     @@@@@@@@@@.
@ECHO    @@@@@    @@@@@@@@@@@@@@@@@   @@@@@ @@@@@@@@@@@  @@@@@        @@@@@@@@@@@
@ECHO    @@@@@    @@@@@      @@@@@@    @@@@@@@@@@  @@@@@@@@@@               @@@@@@
@ECHO    @@@@@   .@@@@@       @@@@@    @@@@@@@@@   @@@@@@@@@        %%@@      @@@@@&
@ECHO    @@@@@   .@@@@@       @@@@@     @@@@@@@,    @@@@@@@       @@@@@@@@@@@@@@@@
@ECHO    @@@@@    @@@@@@@     @@@@@      @@@@@@      @@@@@          @@@@@@@@@@@@
@ECHO              @@@@@@@@@@@@@@@@
@ECHO                    @@@@@@         Twoja sesja pod kontrola
ECHO.
ECHO.
@ECHO    ####################################################################
@ECHO    Wyszukiwarka plikow zamowienia "${clientName}" z sesji "${sessionName}"
@ECHO    ####################################################################
ECHO.
ECHO.

@ECHO Wpisz rozszerzenie plikow, ktorych szukamy, np: jpg, cr2, png itp.
SET /p ext="Jakich plikow szukac?: "
if "%ext%"=="" SET ext=jpg
if "%ext:~0,1%"=="." SET ext=%ext:~1%

SET "destination=%CD%\Skopiowane_zdjecia"
if not exist "%destination%" md "%destination%"

SET copied=0
for %%F in (${photoBases}) do (
    for /r "%CD%" %%A in ("%%~F.%ext%") do (
        copy /Y "%%~fA" "%destination%\" >nul
        set /a copied+=1
        ECHO Skopiowano: %%~nxA
    )
)

ECHO.
@ECHO Skopiowano !copied! plikow do folderu Skopiowane_zdjecia.
ECHO.
@ECHO [Nacisnij dowolny klawisz, aby zamknac okno]
pause >nul`;
}
